import { IUser } from "@/@types";
import { cn } from "@/lib/utils";

interface Props {
  data: IUser;
}

export function TablePaymentStatus({ data }: Props) {
  const className =
    "rounded p-1 gap-3 flex items-center justify-center capitalize";
  const signature = data.signature.toLowerCase() || "unknown";

  if (signature === "blocked")
    return (
      <div className={cn(className, "text-white bg-error")}>{"BLOQUEADO"}</div>
    );

  if (signature === "active")
    return (
      <div className={cn(className, "text-black bg-primary")}>{"ACTIVO"}</div>
    );

  if (signature === "expired")
    return (
      <div className={cn(className, "text-white bg-warning")}>{"EXPIRADO"}</div>
    );

  if (signature === "free")
    return (
      <div className={cn(className, "text-white bg-[#676767]")}>{"GRATIS"}</div>
    );

  if (signature === "promotion")
    return (
      <div className={cn(className, "text-white bg-[#676767]")}>
        {"PROMOÇÃO"}
      </div>
    );

  return (
    <div className={cn(className, "text-white bg-[#676767]")}>{signature}</div>
  );
}
